import React, { useMemo, useState, useCallback } from "react";
import ReactDropdown from "react-dropdown";
import Modal from "react-bootstrap/Modal";

export const SearchBarDestop = ({ dataSearch, setDataSearch, onSearch, listCuaHang, listNguonKH, listTinhTrang }) => {
    const [showModal, setShowModal] = useState(false);
    const toggleModal = () => setShowModal(!showModal);

    const doiTacOptions = useMemo(() => [
        { value: -1, label: "Tất cả" },
        { value: 1, label: "Khách hàng" },
        { value: 0, label: "Chủ nợ" }
    ], []);

    const trangThaiOptions = useMemo(() => [
        { value: -1, label: "Tất cả" },
        { value: 0, label: "Đang vay" },
        { value: 1, label: "Kết thúc" },
        { value: 2, label: "Chưa có hợp đồng" }
    ], []);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setDataSearch(prev => ({ ...prev, [name]: value }));
    };

    const handleDropdownChange = (name, option) => {
        setDataSearch(prev => ({ ...prev, [name]: option.value }));
    };

    const handleSearch = useCallback(() => {
        const newSearchData = { ...dataSearch, pageIndex: 1 };
        onSearch(newSearchData);
        if (showModal) {
            toggleModal();
        }
    }, [onSearch, dataSearch, showModal]);

    const handleKeyDown = (event) => {
        if (event.key === "Enter") {
            handleSearch();
        }
    };

    const dropdownFixStyle = `
        .search-bar-desktop-scope .Dropdown-control.form-control {
            position: relative !important; 
            padding-right: 35px !important; 
        }
        .search-bar-desktop-scope .Dropdown-placeholder,
        .search-bar-desktop-scope .Dropdown-value {
             overflow: hidden !important;
             white-space: nowrap !important;
             text-overflow: ellipsis !important;
             width: 100% !important; 
             display: block !important;
        }
        .search-bar-desktop-scope .Dropdown-arrow-wrapper {
             top: 12px !important;
             right: 10px !important;
        }
        /* Custom style để các cột đều nhau hơn trên desktop */
        .input-new-custom {
            flex: 1;
            min-width: 150px;
            margin-right: 10px;
            margin-bottom: 10px;
        }
        .input-new-custom.large {
            flex: 1.5;
            min-width: 200px;
        }
    `;
    const renderFormFields = () => (
        <>
            <div className="input-sm-new input-new-custom large">
                <label className="font-color-default font-bold">Tìm kiếm</label>
                <input
                    type="text"
                    name="keyword"
                    value={dataSearch.keyword}
                    onChange={handleInputChange}
                    onKeyDown={handleKeyDown}
                    className="form-control input-sm"
                    placeholder="Tên, sđt, CCCD..."
                />
            </div>
            <div className="input-sm-new input-new-custom">
                <label className="font-color-default font-bold">Đối tác</label>
                <ReactDropdown
                    options={doiTacOptions}
                    onChange={(option) => handleDropdownChange('loaiDoiTac', option)}
                    value={doiTacOptions.find(opt => opt.value === dataSearch.loaiDoiTac)}
                    controlClassName="form-control input-sm"
                />
            </div>
            <div className="input-sm-new input-new-custom">
                <label className="font-color-default font-bold">Tình trạng</label>
                <ReactDropdown
                    options={listTinhTrang}
                    onChange={(option) => handleDropdownChange('tinhTrang', option)}
                    value={listTinhTrang.find(opt => opt.value === dataSearch.tinhTrang)}
                    controlClassName="form-control input-sm"
                />
            </div>
            <div className="input-sm-new input-new-custom">
                <label className="font-color-default font-bold">Trạng thái</label>
                <ReactDropdown
                    options={trangThaiOptions}
                    onChange={(option) => handleDropdownChange('trangThai', option)}
                    value={trangThaiOptions.find(opt => opt.value === dataSearch.trangThai)}
                    controlClassName="form-control input-sm"
                />
            </div>
            <div className="input-sm-new input-new-custom">
                <label className="font-color-default font-bold">Nguồn KH</label>
                <ReactDropdown
                    options={listNguonKH}
                    onChange={(option) => handleDropdownChange('nguonKHId', option)}
                    value={listNguonKH.find(opt => opt.value === dataSearch.nguonKHId)}
                    controlClassName="form-control input-sm"
                />
            </div>
            <div className="input-sm-new input-new-custom">
                <label className="font-color-default font-bold">Cửa hàng</label>
                <ReactDropdown
                    options={listCuaHang}
                    onChange={(option) => handleDropdownChange('DBName', option)}
                    value={listCuaHang.find(opt => opt.value === dataSearch.DBName)}
                    controlClassName="form-control input-sm"
                />
            </div>
        </>
    );

    return (
        <div className="search-bar-desktop-scope">
            <style>{dropdownFixStyle}</style>
            <div className="card border-light hidden-mobile-main show-table-main card-v2" style={{ marginTop: "-8px" }}>
                <div className="card-body card-body-v2">
                    <div className="search-new d-flex flex-row align-items-end justify-content-start flex-wrap">
                        {renderFormFields()}
                        <div className="input-sm-new input-new-custom search-main-new" style={{ flex: 'unset', minWidth: 'auto' }}>
                            <button
                                type="button"
                                className="btn btn-info-new"
                                style={{ marginTop: "25px", paddingTop: "7px" }}
                                onClick={handleSearch}
                            >
                                <i className="la la-search"></i>
                                <span> &nbsp; TÌM KIẾM</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="repeater-default hide-table-main show-mobile-main hidden-des-main">
                <div className="col-sm-12">
                    <div className="form row">
                        <div className="col-12">
                            <button
                                type="button"
                                className="btn btn-info-new"
                                onClick={toggleModal}
                                style={{ width: '100%', marginBottom: '10px' }}
                            >
                                Tìm kiếm <i className="la la-search"></i>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <Modal
                show={showModal}
                onHide={toggleModal}
                dialogClassName="modal-lg"
                className="modal-new modal fade text-left search-bar-desktop-scope"
                backdrop="static"
            >
                <Modal.Header>
                    <h2 className="modal-title p-1">Tìm kiếm</h2>
                    <button type="button" className="close-popup-new" onClick={toggleModal}>
                        <img src="/app-assets/images/icon-dong-popup-v2.png" alt="close" />
                    </button>
                </Modal.Header>

                <Modal.Body>
                    <div className="search-new d-flex flex-column">
                        {renderFormFields()}
                    </div>
                </Modal.Body>

                <Modal.Footer>
                    <button type="button" className="btn btn-info" onClick={handleSearch}>
                        <i className="fas fa-search"></i> Tìm kiếm
                    </button>
                    <button type="button" className="btn btn-info" onClick={toggleModal}>
                        <i className="fas fa-times"></i> Đóng
                    </button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default SearchBarDestop;